import { useEffect, useState } from "react";

type Props = {
  savedAt: number | null;
};

function formatRelative(ms: number): string {
  const seconds = Math.floor(ms / 1000);
  if (seconds < 5) return "Saved just now";
  if (seconds < 60) return `Saved ${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `Saved ${minutes}m ago`;
  return "Saved a while ago";
}

export function SaveIndicator({ savedAt }: Props) {
  const [, tick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => tick((n) => n + 1), 10_000);
    return () => clearInterval(id);
  }, []);

  if (!savedAt) {
    return <span className="save-indicator" aria-live="polite" />;
  }
  return (
    <span className="save-indicator" aria-live="polite">
      {formatRelative(Date.now() - savedAt)}
    </span>
  );
}
